import { Adm } from './../../auth/_models/adm';
import { UsersService } from './../../auth/_services/users.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { BlockUi } from 'src/app/auth/_helpers';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-adm-config',
  templateUrl: './adm-config.component.html',
  styleUrls: ['./adm-config.component.css'],
  providers: [UsersService]
})
export class AdmConfigComponent implements OnInit {

  formCreateAdm: FormGroup;

  constructor(
    private _formBuilder: FormBuilder,
    private _blockui: BlockUi,
    private _tostr: ToastrService,
    private _router: Router,
    private _usersService: UsersService,
  ) {
    this.formCreateAdm = _formBuilder.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(6)]],
      passwordCheck: [null, [Validators.required]],
    });
  }

  ngOnInit() {
  }

  get password() {
    return this.formCreateAdm.get('password');
  }

  getControl(field: string): AbstractControl {
    return this.formCreateAdm.get(field);
  }

  verificaValidTouched(field: string) {
    return (
      !this.getControl(field).valid &&
      (this.getControl(field).touched || this.getControl(field).dirty)
    );
  }

  checkValid(control) {
    return {
      'border-danger': this.verificaValidTouched(control)
    };
  }

  onSubmit() {
    const controls = this.formCreateAdm.controls;
    const self = this;

    /**
     * Verifica se o formulário é válido
     */
    if (this.formCreateAdm.valid) {
      this._blockui.block();
      const name: string = this.getControl('name').value,
        email: string = this.getControl('email').value,
        password: string = this.getControl('password').value,
        passwordCheck: string = this.getControl('passwordCheck').value;

      if (password === passwordCheck) {

        const adm: Adm = new Adm({
          name: name,
          email: email,
          password: password
        });

        this._usersService.insertAdm(adm)
          .then(() => {
            this._tostr.success(`Administrador ${adm.name} criado com sucesso!`);
            this._blockui.unblock();
            this.formCreateAdm.reset();
          })
          .catch(error => {
            this._tostr.error('Falha ao criar novo Administrador!');
            this._blockui.unblock();
          });

      } else {
        this._tostr.warning('Confirmação de senha incorreta!');
        this.getControl('password').reset();
        this.getControl('passwordCheck').reset();
        this._blockui.unblock();
      }
    }
  }

}
